<template>
		<div class="j-header van-app-header common-app-header van-nav-bar van-hairline--bottom h5-header">
			<div class="van-nav-bar__content">
				<div class="van-nav-bar__left" @click="goToBack"><i class="header-left van-icon van-icon-arrow-left"><!----></i></div>
				<div class="van-nav-bar__title van-ellipsis"><span
						class="header-title header-title-ellipsis ellipsis">公告信息</span></div>
				<div class="van-nav-bar__right"><span class="header-right"
						style="display: flex; flex-direction: column; align-items: center; color: rgb(23, 24, 38); font-size: 10px; line-height: 18px;"></span>
				</div>
			</div>
		</div>
		<div class="j-main">
			<div data-v-08a8175f="" class="article-content router j-container h5">
				<div data-v-08a8175f="" class="j-container page-container">
					<div data-v-08a8175f="" class="j-main article-content-main show-underline">
						<section data-v-2d1d9b19="" data-v-08a8175f="" class="content-title-container bg-white"><!---->
							<h2 data-v-2d1d9b19="" class="article-title">临汾市尧都区尧庙镇综合便民服务中心物业管理服务二次竞价项目采购公告</h2>
							<div data-v-2d1d9b19="" class="tag-list"><a data-v-2d1d9b19="" href="javascript:void(0);"
									class="j-tag-item border gray round">山西-临汾市-尧都区</a><a data-v-2d1d9b19=""
									href="javascript:void(0);" class="j-tag-item border gray round">竞价</a><a
									data-v-2d1d9b19="" href="javascript:void(0);"
									class="j-tag-item border gray round">政务中心</a><a data-v-2d1d9b19=""
									href="javascript:void(0);" class="j-tag-item border gray round">29.93万元</a></div>
							<!---->
							<div data-v-2d1d9b19="" class="sub-info-line"><span data-v-2d1d9b19=""
									class="info-publish-time">2025-01-27</span>
						
							</div>
							<div data-v-2d1d9b19="" class="sub-info-line">
								<div data-v-2d1d9b19="" class="sub-info-line-l"></div>
								<div data-v-2d1d9b19="" class="sub-info-line-r"><!----></div>
							</div>
						</section><!----><!---->
						<div data-v-08a8175f="" class="van-overlay custom-overlay" style="display: none;"></div>
						<div data-v-08a8175f="" class="van-tabs van-tabs--line">
							<div class="van-tabs__content">
								<div data-v-08a8175f="" role="tabpanel" class="van-tab__pane">
									<section data-v-6cc7245e="" data-v-6f1c48ad="" data-v-08a8175f=""
										class="content-module-card content-main-text-container tab-module">
										<header data-v-6cc7245e=""
											class="content-module-header bg-white flex flex-item-center flex-justify-between">
											<h4 data-v-6cc7245e="" class="content-module-title">公告正文</h4>
											<div data-v-6cc7245e=""
												class="content-module-header-actions flex flex-item-center"></div>
										</header>
										<main data-v-6cc7245e="" class="content-module-main">
											<section data-v-6f1c48ad="" data-v-6cc7245e="" class="content-main-text">
												<pre data-v-6f1c48ad=""
													data-v-6cc7245e="">一、项目基本信息<br>1、框架协议项目名称:2024临汾市公共资源交易中心（临汾市政府采购中心）物业管理服务封闭式<br>2、框架协议项目编号:<span class="keyword keyword-underline my-follow project project-code">SXKJXY-20240131000001</span>.<br>3、预算金额(元):299335.40<br>4、详见采购需求<br>5、采购需求:<br><div class="content-table-container"><table border="1">    <tbody><tr>      <th>序号</th>      <th>需求名称</th>      <th>需求描述</th>      <th>数量</th>      <th>控制单价（元）</th>    </tr>    <tr>      <td>1</td>      <td>物业综合服务</td>      <td>每平方米每年6元 此项为基础服务（必选）</td>      <td>5,128</td>      <td>3.80 </td>    </tr>    <tr>      <td>2</td>      <td>房屋及公共设施设备维修维护</td>      <td>每平方米每年20元（含单件500元及以下维修维护材料）</td>      <td>5,128</td>      <td>11.00 </td>    </tr>    <tr>      <td>3</td>      <td>环境卫生保洁服务<br></td>      <td>每平方米每年12元</td>      <td>5,128</td>      <td>7.00 </td>    </tr>    <tr>      <td>4</td>      <td>秩序维护及安防管理服务-机关安防</td>      <td>每平方米每年16元</td>      <td>5,128</td>      <td>9.00 </td>    </tr>    <tr>      <td>5</td>      <td>秩序维护及安防管理服务-楼内门岗值守</td>      <td>1个出口按3班安排，双人双岗。1个出口以上的，每增加1个增加1人，每人每年45000元</td>      <td>2</td>      <td>28000.00 </td>    </tr>    <tr>      <td>6</td>      <td>秩序维护及安防管理服务-监控室、消控室值守等</td>      <td>按需配置，每人每年45000元</td>      <td>2</td>      <td>28000.00 </td>    </tr>    <tr>      <td>7</td>      <td>绿化养护服务</td>      <td>每平方米每年12元</td>      <td>4,199</td>      <td>7.00 </td>    </tr>  </tbody></table></div><br>商务需求:<br><div class="content-table-container"><table border="1">    <tbody><tr>      <th>序号</th>      <th>需求描述</th>    </tr>    <tr>      <td>1</td>      <td>报价供应商需要在临汾市框架协议内</td>    </tr>    <tr>      <td>2</td>      <td>报价供应商需提前与我方负责人联系，沟通项目具体情况</td>    </tr>  </tbody></table></div><br>二、申请人的资格要求<br>1、满足《中华人民共和国政府采购法》第二十二条规定。<br>2、2024临汾市公共资源交易中心（临汾市政府采购中心）物业管理服务封闭式(框架协议编号:<span class="keyword keyword-underline my-follow project project-code">SXKJXY-20240131000001</span>.)的入围供应商及其在框架协议中载明的委托的代理商。<br>三、供应商报价须知<br>1、本次供应商报价根据框架协议约定，详见采购需求。<br>2、供应商应认真核对报价信息，确保符合采购需求，并对其真实性负责。若与实际不符，一经查实，将视为弄虚作假，当次报价无效，并按政府采购相关规定给予处理。<br>四、二次竞价规则<br>1、报价规则<br>(1)&nbsp;供应商的报价应为单价或是优惠率。<br>(2)&nbsp; 供应商的报价不得高于协议限价。<br>2、成交规则、终止规则<br>(1)&nbsp;成交规则:在响应时间内报价有效且符合竞价需求的，报价最低的为成交供应商。当多家供应商价格一致目均为最低报价时，系统默认报价时间最早的供应商为成交供应商。<br>(2)&nbsp;终止规则:在二次竞价公告期间，采购人因故取消采购任务;或者无符合竞价需求且报价有效供应商的，竞价终止。<br>五、二次竞价响应时间、地点、要求<br>二次竞价响应时间:2025年01月28日 00:00:00至2025年01月29日 00:00:00<br>地点:山西省政府采购电子卖场<br>方式:供应商在二次竞价响应时间内，通过山西省政府采购电子卖场进行报价<br>六、服务时间、地点及支付条件<br>交货时间:合同生效之日起个日历天内。<br>交货地点:山西省临汾市尧都区临汾市尧都区尧庙镇尧庙村尧都大道北侧<br>货款支付:采购人应在完成验收后5个工作日内按照有关规定办理资金支付手续。<br>七、项目联系方式<br>联系人:  临汾市尧都区尧庙镇综合便民服务中心<br>联系方式: 19834422117<br>采购单位：临汾市尧都区尧庙镇综合便民服务中心<br>八、公告期限<br>自本公告发布之日起1个工作日。<br>采购单位:临汾市尧都区尧庙镇综合便民服务中心<br>2025年01月27日</pre>
											</section><!---->
											<div data-v-6f1c48ad="" data-v-6cc7245e=""></div><!---->
										
											<section data-v-6f1c48ad="" data-v-6cc7245e="" class="others-footer"><!---->
											</section>
										</main>
										<footer data-v-6cc7245e="" class="content-module-footer"></footer>
									</section>
							
								</div>
								</div>
						</div><!---->
					
					</div>
				
				</div>
			
			</div>
		</div>
		<div class="j-footer"></div>

</template>

<script>
	//import { ref } from 'vue';
	import { useRouter } from 'vue-router'; 
	export default {
		name: 'ContentPage',
		props: {
			msg: String
		},
		setup() {

			
			
			const router = useRouter();
			
			const goToBack = () => {
				router.back();
			};
			
			
			return {
				goToBack
			};
		},
		mounted() {
			//const router = useRouter();  // 获取 Vue Router 实例
			//const { keyword } = this.$router.query;
			this.inputValue = this.$route.query.id;
			console.log(this.$route.query.id);  // 输出查询参数 id 和 name
		}

	}
</script>


<style scoped>
	@import url('https://cdn-common.jianyu360.cn/jy_mobile/assets/index-839a8260.css');  /* 引入远程 CSS 文件 */
	@import url('https://cdn-common.jianyu360.cn/jy_mobile/assets/index-36bb932e.css');
	@import url('https://cdn-common.jianyu360.cn/jy_mobile/assets/content-9fe20172.css');
	
</style>